export default __webpack_public_path__ + "static/media/files.b597ea0a.svg";